module.exports = __webpack_public_path__ + "assets/img/sina.a67598a0.png";